'use client';

import Image from '@/components/Image';
import { SingleImageBlock } from '../types';
import { useValidExposure } from '@/hooks/useValidExposure';
import { useCallback } from 'react';

interface SingleImageProps {
  isWeb: boolean;
  content: SingleImageBlock;
  index: number;
  trackADExp: (
    moduleName: string,
    pitsIndex: number,
    pitsJumpType?: string,
    pitsJumpContent?: string,
  ) => void;
}

export default function SingleImage({ isWeb, content, index, trackADExp }: SingleImageProps) {
  const {
    pc_image,
    mobile_image,
    pc_width,
    pc_height,
    mobile_width,
    mobile_height,
    image_alt,
    module_name,
  } = content;
  const image = isWeb ? pc_image : mobile_image;
  const width = isWeb ? pc_width : mobile_width;
  const height = isWeb ? pc_height : mobile_height;

  const { ref: validExposureRef } = useValidExposure({
    callback: useCallback(() => {
      trackADExp(module_name, index, '0');
    }, [module_name, index, trackADExp]),
  });

  return (
    <section
      ref={validExposureRef}
      className="relative w-full bg-white flex"
      style={{ aspectRatio: `${width}/${height}` }}
    >
      <Image className="block w-full h-auto object-cover" src={image} alt={image_alt} fill />
    </section>
  );
}
